import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import AdminActivity from './admin/AdminActivity';
import AdminBanner from './admin/AdminBanner';
import AdminContent from './admin/AdminContent';
import AdminDashboard from './admin/AdminDashboard';
import AdminLayout from './admin/AdminLayout';
import AdminLogin from './admin/AdminLogin';
import ProtectedRoute from './admin/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { SiteContentProvider } from './context/SiteContentContext';
import PublicSite from './pages/PublicSite';
import { trackPageView } from './utils/analytics';

function AppAnalytics() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <SiteContentProvider>
        <AppAnalytics />
        <Routes>
          <Route path="/" element={<PublicSite />} />
          <Route path="/admin">
            <Route index element={<AdminLogin />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AdminLayout />}>
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="banner" element={<AdminBanner />} />
                <Route path="activity" element={<AdminActivity />} />
                <Route path="content" element={<AdminContent />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </SiteContentProvider>
    </AuthProvider>
  );
}

export default App;
